import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { deleteGuideline } from "../api";

export function useDeleteGuideline(): UseMutationResult<void, Error, string> {
  return useMbcAdminMutation(deleteGuideline, mbcAdminKeys.guidelines());
}
